<script setup lang="ts">
import { computed } from '#imports'

interface Props {
  buttonBorderRadius?: string
  label: string
  required?: boolean
}

const { buttonBorderRadius = 'rounded-full', label } = defineProps<Props>()

const modelValue = defineModel<string[]>()

defineEmits<{
  clear: []
  click: []
}>()

const isActive = computed(() => Boolean(modelValue.value?.length))
const optionalClasses = computed(() => {
  return {
    [buttonBorderRadius]: buttonBorderRadius,
  }
})

const truncatedName = computed(() => {
  const name = modelValue.value?.[0] ?? ''
  if (name.length > 10) {
    return `${name.slice(0, 10)}...`
  }
  return name
})
</script>

<template>
  <button
    class="inline-flex h-full max-h-10 items-center justify-center space-x-2 border border-neutral-200 px-3 py-2"
    :class="{
      ...optionalClasses,
      'bg-secondary-50 text-secondary-800 border-transparent': isActive,
      'text-neutral-800': !isActive,
    }"
    type="button"
    @click="$emit('click')"
  >
    <span class="subtitle-2 flex">
      <slot name="icon" />
      <span class="max-w-xs truncate whitespace-nowrap">
        {{ modelValue?.length ? `${label}: ${truncatedName}` : label }}
      </span>
      <span v-if="modelValue?.length && modelValue.length > 1">
        , +{{ modelValue?.length - 1 }}
      </span>
      <template v-if="label === 'Import CSV'">
        <span
          v-if="modelValue?.length"
          class="ml-2 flex h-4 w-4 cursor-pointer items-center justify-center"
          @click.stop="$emit('clear')"
        >
          <i class="i-ph-x-bold h-4 w-4" />
        </span>
        <span v-else class="ml-2 flex h-4 w-4 items-center justify-center">
          <i class="i-ph-upload-simple h-4 w-4" />
        </span>
      </template>
      <span v-else class="ml-2 flex h-4 w-4 items-center justify-center">
        <i class="i-ph-caret-down-bold h-4 w-4" />
      </span>
    </span>
  </button>
</template>
